module.exports = __webpack_public_path__ + "img/category-preotective-gear.acb3fc29.svg";